module.exports = __webpack_public_path__ + "static/img/1_2_2_2.7fff3967.jpg";